module.exports = __webpack_public_path__ + "img/ah01.fb84c8a0.jpg";